// Returns the lowercased text of the punchline word at a given order, or
// null if order isn't a valid single index (e.g. the [] "nothing
// hovered" sentinel bucketHover dispatches, or -1 "nothing selected").
export function wordTextAt(punchline_words, order) {
  if (order == null || order === -1 || Array.isArray(order)) {
    return null;
  }
  const match = punchline_words.find(w => w.order === order);
  return match ? match.word.toLowerCase() : null;
}

// Whether dropping/placing the word at dragged_order onto the bucket at
// bucket_order should count as correct. Compares word *text*, not
// position: a punchline with a repeated word (e.g. "to get to the X")
// shows two identical-looking tiles, and there's no way for a player to
// tell which original slot either one came from - so either tile is
// accepted for either matching slot, as long as that slot isn't already
// filled.
export function isCorrectMatch(punchline_words, words_correct, dragged_order, bucket_order) {
  if (bucket_order == null || Array.isArray(bucket_order) || words_correct[bucket_order]) {
    return false;
  }
  const dragged_text = wordTextAt(punchline_words, dragged_order);
  const target_text = wordTextAt(punchline_words, bucket_order);
  return dragged_text !== null && dragged_text === target_text;
}
